export const styles = theme => ({
  helperText: {
    color: theme.palette.error.main
  }
})



// WEBPACK FOOTER //
// ./src/components/Input/styles.js